import React, { PropsWithChildren, useCallback } from 'react'
import {
  ComponentSwitchCase,
  ComponentSwitchCaseProps,
} from './ComponentSwitchCase'

export interface ComponentSwitchProps extends PropsWithChildren<object> {}

const ComponentSwitch: React.FC<ComponentSwitchProps> = ({ children }) => {
  const getValidChildren = useCallback(() => {
    const returnChildren: JSX.Element[] = []

    React.Children.forEach(children, child => {
      if (!React.isValidElement(child)) return

      if (
        typeof child.props.case === 'undefined' &&
        typeof child.props.default === 'undefined'
      )
        return
      if (
        typeof child.props.case !== 'undefined' &&
        typeof child.props.case !== 'boolean'
      )
        return
      if (
        typeof child.props.default !== 'undefined' &&
        typeof child.props.default !== 'boolean'
      )
        return

      returnChildren.push(child)
    })

    return returnChildren
  }, [children])

  const getDefaultChild = useCallback((validChildren: JSX.Element[]) => {
    return (
      validChildren.find(c => typeof c.props.default === 'boolean') ?? (
        <>{null}</>
      )
    )
  }, [])

  const renderCase = useCallback(() => {
    const validChildren = getValidChildren()

    for (const child of validChildren) {
      if ((child as JSX.Element).props.case) return child
    }

    const defaultChild = getDefaultChild(validChildren)

    return React.cloneElement(defaultChild)
  }, [getValidChildren, getDefaultChild])

  return <>{renderCase()}</>
}

interface ComponentSwitchCaseFC extends React.FC<ComponentSwitchProps> {
  Case: React.FC<ComponentSwitchCaseProps>
}
;(ComponentSwitch as ComponentSwitchCaseFC).Case = ComponentSwitchCase
const ComponentSwitchWithCase = ComponentSwitch as ComponentSwitchCaseFC

export { ComponentSwitchWithCase as ComponentSwitch }
